var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4023,
    cy: 14.7453,
    r: 14.652,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6737 8.88622L20.52 7.73254C20.0513 7.2631 19.4157 7 18.7525 7H9.12504C8.17564 7 7.40625 7.76939 7.40625 8.71879V20.2812C7.40625 21.2306 8.17564 22 9.12504 22H20.6875C21.6369 22 22.4062 21.2306 22.4062 20.2812V10.6538C22.4062 9.99057 22.1432 9.35497 21.6737 8.88622ZM9.90621 10.9062V9.34375C9.90621 9.085 10.1162 8.875 10.375 8.875H16.9375C17.1962 8.875 17.4062 9.085 17.4062 9.34375V10.9062C17.4062 11.165 17.1962 11.375 16.9375 11.375H10.375C10.1162 11.375 9.90621 11.165 9.90621 10.9062ZM14.9062 19.5C13.3532 19.5 12.0938 18.2406 12.0938 16.6875C12.0938 15.1343 13.3532 13.875 14.9062 13.875C16.4593 13.875 17.7188 15.1343 17.7188 16.6875C17.7188 18.2406 16.4593 19.5 14.9062 19.5Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(7.40625 7)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.32603c2b.svg";
export { ForwardRef as ReactComponent };